var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"align",attrs:{"id":"scrEnd"}},[_c('IconBase',{attrs:{"viewBox":"0 0 68 68"}},[_c('icon')],1),_c('p',{staticClass:"ln1"},[_vm._v("Спасибо!")]),_c('p',{staticClass:"ln2"},[_vm._v("Ваша заявка была предварительно одобрена.")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }